import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';


const NoGLCodeRule = (props) => {
  const {
    form, type, onSubmit, initialValues, ...other
  } = props;

  const submit = useCallback((event) => {
    event.preventDefault();
    onSubmit({
      kind: 'no_glcode',
      regions: [],
      value: {}
    });
  }, [onSubmit]);


  return (
    <RuleForm
      {...other}
      onSubmit={submit}
      isSubmitting={form.is_submitting}
    >
    </RuleForm>
  );
};

NoGLCodeRule.defaultProps = {
  type: 'add',
  initialValues: {}
};

NoGLCodeRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default NoGLCodeRule;
